export default __webpack_public_path__ + "static/media/credit-card.1291ee1a.svg";